import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthLayout } from '@app/layouts/AuthLayout';
import { MainLayout } from '@app/layouts/MainLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { RouteFallback } from './RouteFallback';

const LoginView = lazy(() =>
  import('@features/auth/views/LoginView').then((m) => ({ default: m.LoginView })),
);
const DashboardView = lazy(() =>
  import('@features/dashboard/views/DashboardView').then((m) => ({ default: m.DashboardView })),
);
const WorkspacesView = lazy(() =>
  import('@features/workspaces/views/WorkspacesView').then((m) => ({ default: m.WorkspacesView })),
);
const PlansView = lazy(() =>
  import('@features/plans/views/PlansView').then((m) => ({ default: m.PlansView })),
);
const FreeCodesView = lazy(() =>
  import('@features/free-codes/views/FreeCodesView').then((m) => ({ default: m.FreeCodesView })),
);
const AuditView = lazy(() =>
  import('@features/audit/views/AuditView').then((m) => ({ default: m.AuditView })),
);
const NotFoundView = lazy(() =>
  import('@app/router/NotFoundView').then((m) => ({ default: m.NotFoundView })),
);
const UiKitShowcaseView = lazy(() =>
  import('@app/router/UiKitShowcaseView').then((m) => ({ default: m.UiKitShowcaseView })),
);

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginView />} />
        </Route>

        {import.meta.env.DEV && (
          <Route element={<MainLayout />}>
            <Route path="/_kit" element={<UiKitShowcaseView />} />
          </Route>
        )}

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardView />} />
            <Route path="/workspaces" element={<WorkspacesView />} />
            <Route path="/plans" element={<PlansView />} />
            <Route path="/free-codes" element={<FreeCodesView />} />
            <Route path="/audit" element={<AuditView />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Suspense>
  );
}
